import { cn } from "@/lib/cn";

interface WordmarkProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizes = { sm: "text-sm", md: "text-xl", lg: "text-3xl" };

export function Wordmark({ size = "md", className }: WordmarkProps) {
  return (
    <span
      className={cn(
        "font-bold uppercase tracking-[0.15em] select-none",
        "bg-gradient-to-r from-fg to-fg-muted bg-clip-text text-transparent",
        sizes[size],
        className,
      )}
    >
      OMNI
    </span>
  );
}
